import { Box, Container, Grid } from '@mui/material'

import HeaderContainer from '@/src/components/common/header/HeaderRouter'
import FlightScheduleFooter from '@/src/components/desktop/srp/flightSchedule/footer'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'

import DestinationBreadcrumbs from '@/src/components/common/destination/destinationBreadcrumbs'
import DestinationHeroWrapper from '@/src/components/common/destination/destinationHero'
import DestinationSectionsWrapper from '@/src/components/common/destination'
import TopHotelsWrapper from '@/src/components/common/destination/topHotels'

const DestinationDesktopPage: React.FC<{ domainCountry: string }> = ({ domainCountry }) => {
    return (
        <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', display: 'flex', flexDirection: 'column', overflowX: 'hidden' }}>
            <ErrorBoundaryWrapper identifier="destination-header-desktop">
                <HeaderContainer domainCountry={domainCountry} />
            </ErrorBoundaryWrapper>

            <ErrorBoundaryWrapper identifier="destination-hero-desktop">
                <DestinationHeroWrapper isMobile={false} />
            </ErrorBoundaryWrapper>

            <Container component="main" maxWidth="lg" sx={{ py: 4 }}>
                <ErrorBoundaryWrapper identifier="destination-breadcrumbs-desktop">
                    <DestinationBreadcrumbs />
                </ErrorBoundaryWrapper>
                <Grid container spacing={3} alignItems="flex-start">
                    <Grid size={{ xs: 12, md: 8 }}>
                        <ErrorBoundaryWrapper identifier="destination-sections-desktop">
                            <DestinationSectionsWrapper />
                        </ErrorBoundaryWrapper>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <ErrorBoundaryWrapper identifier="destination-tophotels-desktop">
                            <TopHotelsWrapper />
                        </ErrorBoundaryWrapper>
                    </Grid>
                </Grid>
            </Container>
            <Box sx={{ mt: 'auto' }}>
                <FlightScheduleFooter />
            </Box>
        </Box>
    )
}

export default DestinationDesktopPage
